"use client";

import { Input, Button } from "@/ui";
import { ENHANCEMENT_OPTIONS } from "../enhancementPrompts";
import styles from "./PromptMenu.module.css";

export function PromptMenu({
  onClose,
  onEnhancementSelect,
  userCustomPrompt,
  onCustomPromptChange,
  onCustomEnhancement,
  excludePrompts = [],
}) {
  return (
    <div className={styles.menu}>
      <div className={styles.header}>
        <span className={styles.headerLabel}>
          <img
            src="/img/floats/sola.svg"
            width="16"
            height="16"
            alt=""
            className={styles.solaIcon}
          />
          Pick a prompt below, or tell SOLA exactly what you need
        </span>
        <Button
          type="button"
          variant="tertiary"
          color="pink"
          size="sm"
          noPadding
          onClick={onClose}
        >
          Done
        </Button>
      </div>

      <div className={styles.grid}>
        {ENHANCEMENT_OPTIONS.filter(
          (option) => option.id !== "custom" && !excludePrompts.includes(option.id)
        ).map(
          (option) => {
            const Icon = option.icon;
            return (
              <button
                key={option.id}
                type="button"
                className={styles.promptButton}
                onClick={() => onEnhancementSelect(option.id)}
              >
                <Icon size={14} />
                <span>{option.label}</span>
              </button>
            );
          }
        )}
      </div>

      <div className={styles.customPromptRow}>
        <Input
          className={styles.customPromptField}
          value={userCustomPrompt}
          onChange={onCustomPromptChange}
          placeholder="Ask anything, eg. Make it more localised to Sydney"
          size="lg"
          endIcon={
            <button
              type="button"
              className={styles.customPromptTrigger}
              onClick={onCustomEnhancement}
              title="Enhance with custom prompt"
            >
              <img src="/img/floats/sola.svg" alt="" />
            </button>
          }
        />
      </div>
    </div>
  );
}
